// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"b92f9d39","605":"ade6a60f","725":"40f1a262"}[chunkId] + ".chunk.js";
};